export default {
  recentNews: [
    {
      imgUrl:
    'http://imgcdn.lanxiongsports.com//ueditor/php/upload/image/20230111/1673408920986158.jpg',
       title: '懒熊体育创始人&CEO韩牧：结束等待，欢迎上场',
        link: 'http://lanxiongsports.com/posts/view/id/23358.html',
      },

    {
      imgUrl:
    'http://imgcdn.lanxiongsports.com//ueditor/php/upload/image/20230111/1673415252686651.jpg',
       title: '体育产业嘉年华·创业场：企业还活着就开心，要在不确定中找到确定性',
        link: 'http://www.lanxiongsports.com/posts/view/id/23372.html',
      },

    {
      imgUrl:
       'http://imgcdn.lanxiongsports.com//ueditor/php/upload/image/20230112/1673487675209922.jpg',
       title: '2022体育产业的年度榜样，这里有16个',
       link: 'http://lanxiongsports.com/posts/view/id/23379.html',
    },



   // { 
   //   imgUrl:
   //   'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610440981.JPG',
   // title: '体育·新城市：城市更新，体育发挥重要作用',
   //  link: 'http://lanxiongsports.com/posts/view/id/20375.html',
  // },
  //    {
  //  imgUrl:
  //    'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610417333.jpg',
  //   title: '懒熊体育创始人韩牧：产业5年发展的5点观察，不断进化才能蓄势而上',
  //   link: 'http://lanxiongsports.com/posts/view/id/20380.html',
  // },

  //  {
  //    imgUrl:
  //      'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610432781.JPG',
  //    title: '体育·新消费：零售业就是“泥水中摸爬滚打”，要用长远眼光做眼前生意',
 //     link:
 //       'http://lanxiongsports.com/posts/view/id/20373.html',
 //   },
   // {
   //   imgUrl:
   //     'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610425916.jpg',
   //   title: '体育·新内容：疫情撕去最后面纱，版权市场将迎来健康发展',
   //   link:
  //      'http://lanxiongsports.com/posts/view/id/20372.html',
  //  },

//    {
//      imgUrl:
//        'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610424279.jpg',
//      title: '体育·新趋势：2020体育产业已然触底，未来体育公司需增强抵御风险能力',
//      link: 'http://lanxiongsports.com/posts/view/id/20371.html',
//    },
//    {
//      imgUrl:
//        'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610417333.jpg',
//      title: '懒熊体育创始人韩牧：体育产业五年发展“喜忧参半”，不断进化才能“蓄势而上”',
//     link: 'http://lanxiongsports.com/posts/view/id/20370.html',
//   },
//   {
//     imgUrl:
//      'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610440981.JPG',
//     title: '体育·新城市：城市更新，体育发挥重要作用',
//     link: 'http://lanxiongsports.com/posts/view/id/20375.html',
//   },

  ],
  album: [

    {
      imgUrl:
        'https://imgcdn.lanxiongsports.com/img/jnh2022/album/XUC0591.JPG',
      title: '第七届体育产业嘉年华现场',
      link:
        'https://live.photoplus.cn/live/pc/69937731/#/live',
    },

    {
      imgUrl:
        'https://imgcdn.lanxiongsports.com/img/jnh2022/album/XUC0213.JPG',
      title: '第七届体育产业嘉年华现场',
      link:
        'https://live.photoplus.cn/live/pc/69937731/#/live',
    },

    {
      imgUrl:
        'https://imgcdn.lanxiongsports.com/img/jnh2022/album/XF4439.JPG',
      title: '第七届体育产业嘉年华现场',
      link:
        'https://live.photoplus.cn/live/pc/69937731/#/live',
    },

//    {
//      imgUrl:
//        'https://imgcdn.lanxiongsports.com/jnh20/album/WEN2521_w3311.jpg',
//      title: '体育·新消费：双循环下再升级',
//      link:
//        'https://live.photoplus.cn/live/pc/56912780/#/live',
//    },
//    {
//      imgUrl:
//        'https://imgcdn.lanxiongsports.com/jnh20/album/WEN2418_w8580.jpg',
//     title: '体育·新内容：理性与感性',
//      link:
//        'https://live.photoplus.cn/live/pc/56912780/#/live',
//    },

  ],
  videosList: [
    {
      imgUrl: 'http://imgcdn.lanxiongsports.com/carnival_vid_cover.jpeg',
      title: '“赶路的人”首届体育产业嘉年华回顾',
      link: 'http://www.lanxiongsports.com/posts/view/id/4941.html',
    },
    {
      imgUrl: 'http://imgcdn.lanxiongsports.com/upload/carnival/news3.jpg',
      title: '“潮前走”第二届中国体育产业嘉年华回顾',
      link: 'http://www.lanxiongsports.com/posts/view/id/4941.html',
    },
    {
      imgUrl: 'http://imgcdn.lanxiongsports.com/upload/carnival/news4.png',
      title: '“赶路的人”首届体育产业嘉年华回顾',
      link: 'http://www.lanxiongsports.com/posts/view/id/4941.html',
    },
  ],
};
